export const openWindowsKey = 'mecenas_chat_open_windows';
export const minimizedWindowsKey = 'mecenas_chat_minimized_windows';
